import React, { memo } from 'react'

import type { FontSize, Variant } from '../../../themes/types'
import { StyledBadge } from './Badge.styles'

export type BadgePosition = 'right' | 'left'
type BadgeContent = number | string

export interface BadgeProps {
  'data-e2e'?: string
  className?: string
  content?: BadgeContent
  floating?: boolean
  fontVariant?: Variant
  position?: BadgePosition
  size?: FontSize
  variant?: Variant
}

const canDisplayBadge = (content?: BadgeContent) => {
  if (typeof content === 'number' && content > 0) return true
  if (typeof content === 'string' && content.length > 0) return true

  return false
}

const Badge = ({
  'data-e2e': dataE2e,
  className,
  content,
  floating = false,
  fontVariant,
  position,
  size = 'small',
  variant = 'neutral',
}: BadgeProps) =>
  canDisplayBadge(content) ? (
    <StyledBadge
      className={className}
      data-e2e={dataE2e}
      floating={floating}
      fontVariant={fontVariant}
      position={position}
      size={size}
      variant={variant}
    >
      {content}
    </StyledBadge>
  ) : null

export default memo(Badge)
